module.exports = __webpack_public_path__ + "img/twitter-white.52d87225.svg";